import { useGetCountries } from 'api/countries/use-get-countries.ts';
import { useGetManyWarehouses } from 'api/warehouses/use-get-many-warehouses.ts';
import { AuditLogItem } from 'components/common/audit-logs/components/audit-log-item';
import styles from './audit-logs-list.module.scss';
import type { IAuditLogsListProps } from './types.ts';
import { getCorrelationGroupPosition } from './utils.ts';

export const AuditLogsList: React.FC<IAuditLogsListProps> = (props) => {
  const { auditLogs, currentEntity } = props;
  const { data: countries } = useGetCountries();
  const { data: warehouses } = useGetManyWarehouses({ withDeprecated: true });

  return (
    <div className={styles.list}>
      {auditLogs.map((auditLog, index) => {
        const { isGrouped, hasSameNextCorrelation } = getCorrelationGroupPosition(auditLogs, index);

        return (
          <AuditLogItem
            key={auditLog.id}
            auditLog={auditLog}
            currentEntity={currentEntity}
            referenceData={{ countries, warehouses }}
            isGrouped={isGrouped}
            hasSameNextCorrelation={hasSameNextCorrelation}
          />
        );
      })}
    </div>
  );
};
